<div class="container-fluid text-center justify-content-center my-3">
    <img src="assets/images/logoCertant2.svg" alt=" Certant" class="img-fluid" width="180">
</div>
